import { render } from "./ClientesConquistados.vue?vue&type=template&id=0eaddfed"
import script from "./ClientesConquistados.vue?vue&type=script&lang=js"
export * from "./ClientesConquistados.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__